(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    function sbCartDrawerParts(el) {
    var root = el.closest('[data-cart-drawer]');
    if (!root) return null;
    var details = root.querySelector('[data-cart-drawer-details]');
    if (!details) return null;
    var panel = details.querySelector('.cart-drawer__panel');
    return { root: root, details: details, panel: panel };
  }

  function sbCartDrawerOpen(root, details) {
    // Safari sur iPhone calcule parfois mal une largeur en CSS (100%) au
    // moment précis où le panier apparaît. On mesure donc la largeur
    // réelle de l'écran nous-mêmes, en JavaScript, et on l'impose
    // directement en pixels — beaucoup plus fiable.
    var panel = details.querySelector('.cart-drawer__panel');
    if (panel) {
      var w = Math.min(window.innerWidth, 500);
      panel.style.setProperty('width', w + 'px', 'important');
    }
    details.open = true;
    requestAnimationFrame(function () {
      root.classList.add('cart-open');
    });
  }

  function sbCartDrawerClose(root, details, panel) {
    root.classList.remove('cart-open');
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      details.open = false;
    }
    if (panel) {
      panel.addEventListener('transitionend', finish, { once: true });
    }
    setTimeout(finish, 400);
  }

  // Tout est branché ici par "délégation" (un seul écouteur sur le
  // document entier, qui regarde ensuite sur quel bouton on a cliqué) —
  // pas d'écouteur posé directement sur chaque bouton. C'est important :
  // quand un article est ajouté au panier, le contenu à l'intérieur du
  // panier est régénéré par le thème, ce qui remplacerait des écouteurs
  // posés à l'ancienne. La délégation, elle, continue de fonctionner
  // même après un tel remplacement.
  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-cart-drawer-open]');
    if (openBtn) {
      var parts = sbCartDrawerParts(openBtn);
      if (parts) {
        event.preventDefault();
        sbCartDrawerOpen(parts.root, parts.details);
      }
      return;
    }

    var closeBtn = event.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      var parts2 = sbCartDrawerParts(closeBtn);
      if (parts2) {
        event.preventDefault();
        sbCartDrawerClose(parts2.root, parts2.details, parts2.panel);
      }
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-cart-drawer-details][open]').forEach(function (details) {
      var root = details.closest('[data-cart-drawer]');
      if (!root) return;
      var panel = details.querySelector('.cart-drawer__panel');
      sbCartDrawerClose(root, details, panel);
    });
  });

  // Ouverture automatique après un ajout au panier (Mon Introspection,
  // Création libre, ou n'importe quel bouton "Ajouter au panier" standard
  // du thème) : ils déclenchent tous l'événement "cart:update".
  document.addEventListener('cart:update', function () {
    document.querySelectorAll('[data-cart-drawer][data-auto-open]').forEach(function (root) {
      var details = root.querySelector('[data-cart-drawer-details]');
      if (details) sbCartDrawerOpen(root, details);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    // Carte cadeau : recupere le choix numerique / physique et l'adresse, puis
  // envoie l'article au panier directement, comme le fait deja Creation libre.
  // Ce code vit ici et non dans le bloc de la page produit, car la boutique
  // n'execute pas le JavaScript ecrit dans ce bloc.
  (function () {
    function bloc() {
      var tous = document.querySelectorAll('.carte-livraison-choice');
      return tous.length ? tous[tous.length - 1] : null;
    }

    function estPhysique() {
      var b = bloc();
      if (!b) return false;
      var coche = b.querySelector('input[name="carte_format_choice"]:checked');
      return !!coche && coche.value === 'physique';
    }

    function informations() {
      var physique = estPhysique();
      var props = {};

      props['Format de la carte'] = physique
        ? 'Carte physique (envoyée par courrier)'
        : 'Carte numérique (reçue par email)';

      if (physique) {
        var b = bloc();
        if (b) {
          var champs = b.querySelectorAll('.carte-adresse-fields input');
          for (var i = 0; i < champs.length; i++) {
            var v = (champs[i].value || '').trim();
            if (v) {
              props[champs[i].getAttribute('data-field')] = v;
            }
          }
        }
      }
      return props;
    }

    function majAffichage() {
      var b = bloc();
      if (!b) return;

      var zoneChamps = b.querySelector('.carte-physique-fields');
      if (zoneChamps) {
        zoneChamps.hidden = !estPhysique();
      }

      var zoneVerif = b.querySelector('[data-verif-contenu]');
      if (zoneVerif) {
        var props = informations();
        var texte = '';
        for (var cle in props) {
          if (Object.prototype.hasOwnProperty.call(props, cle)) {
            texte += cle + ' : ' + props[cle] + '\n';
          }
        }
        zoneVerif.textContent = texte;
      }
    }

    document.addEventListener('change', majAffichage);
    document.addEventListener('input', majAffichage);
    document.addEventListener('DOMContentLoaded', majAffichage);
    document.addEventListener('cart:update', majAffichage);
    setTimeout(majAffichage, 200);
    setTimeout(majAffichage, 1000);

    // On prend la main sur le bouton "Ajouter au panier" de la carte cadeau
    // uniquement, et on envoie l'article nous-memes avec ses informations.
    document.addEventListener('click', function (event) {
      if (!bloc()) return;
      if (!event.target || !event.target.closest) return;

      var bouton = event.target.closest('button');
      if (!bouton) return;
      if (bouton.type && bouton.type !== 'submit') return;

      var form = bouton.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      var champId = form.querySelector('input[name="id"]');
      var variante = champId ? champId.value : '';
      if (!variante) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      // On desactive le bouton le temps de l'ajout, sans jamais toucher a son
      // contenu : le theme y superpose deux libelles ("Ajouter au panier" et
      // "Ajoute"), et les reecrire les ferait apparaitre tous les deux.
      bouton.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variante, quantity: 1, properties: informations() }]
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: {}, sourceId: 'symbolink-carte-cadeau', data: {} }
          }));
        })
        .catch(function (erreur) {
          console.error('[Symbolink] Ajout au panier impossible :', erreur);
        })
        .then(function () {
          bouton.removeAttribute('disabled');
        });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
